import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import SubscriptionSearch from './search/SubscriptionSearch'
import Subscription from './Subscription'

export default class SubscriptionManager extends React.Component {
  render = () => {
    const { match } = this.props

    return (
      <ErrorBoundary>
        <Switch>
          <Route component={Subscription} path={`${match.path}/:id`} />
          <Route component={SubscriptionSearch} path={match.path} />
        </Switch>
      </ErrorBoundary>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/SubscriptionManager.js